import { useState, useEffect } from 'react';
import AboutModal from '../../pages/home/components/AboutModal';
import CareersModal from '../../pages/home/components/CareersModal';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isCareersOpen, setIsCareersOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (!element) return;
    const offset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  const scrollToTop = () => {
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const textColor = isScrolled || isMobileMenuOpen ? 'text-[#1A365D]' : 'text-white';

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || isMobileMenuOpen ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo & Brand */}
            <div
              className="flex items-center space-x-2 cursor-pointer"
              onClick={scrollToTop}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/95973eac-e27a-474d-996f-33ddc4a2bb23.png"
                alt="McALLISTER DELIGHT Logo"
                title="McALLISTER DELIGHT - Food Logistics in Canada"
                className="h-9 md:h-12 w-auto object-contain"
              />
              <span className={`text-sm md:text-lg font-bold transition-colors ${textColor}`}>
                McALLISTER DELIGHT
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={scrollToTop}
                className={`text-sm font-medium transition-colors hover:text-[#DC2626] whitespace-nowrap ${isScrolled ? 'text-[#1A365D]' : 'text-white'}`}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className={`text-sm font-medium transition-colors hover:text-[#DC2626] whitespace-nowrap ${isScrolled ? 'text-[#1A365D]' : 'text-white'}`}
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('news')}
                className={`text-sm font-medium transition-colors hover:text-[#DC2626] whitespace-nowrap ${isScrolled ? 'text-[#1A365D]' : 'text-white'}`}
              >
                News
              </button>
              <button
                onClick={() => { setIsMobileMenuOpen(false); setIsAboutOpen(true); }}
                className={`text-sm font-medium transition-colors hover:text-[#DC2626] whitespace-nowrap ${isScrolled ? 'text-[#1A365D]' : 'text-white'}`}
              >
                About Us
              </button>
              <button
                onClick={() => { setIsMobileMenuOpen(false); setIsCareersOpen(true); }}
                className={`text-sm font-medium transition-colors hover:text-[#DC2626] whitespace-nowrap ${isScrolled ? 'text-[#1A365D]' : 'text-white'}`}
              >
                Careers
              </button>
            </div>

            {/* Right side */}
            <div className="flex items-center space-x-3">
              <button
                onClick={() => scrollToSection('contact')}
                className="hidden md:block bg-[#DC2626] text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#B91C1C] transition-colors whitespace-nowrap"
              >
                Get a Quote
              </button>

              {/* Hamburger */}
              <button
                onClick={() => setIsMobileMenuOpen((v) => !v)}
                className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                  isScrolled || isMobileMenuOpen
                    ? 'text-[#1A365D] hover:bg-gray-100'
                    : 'text-white hover:bg-white/10'
                }`}
                aria-label="Toggle menu"
              >
                <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-1">
            <button
              onClick={scrollToTop}
              className="w-full text-left px-4 py-3 rounded-xl text-[#1A365D] font-medium hover:bg-gray-50 transition-colors cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="w-full text-left px-4 py-3 rounded-xl text-[#1A365D] font-medium hover:bg-gray-50 transition-colors cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('news')}
              className="w-full text-left px-4 py-3 rounded-xl text-[#1A365D] font-medium hover:bg-gray-50 transition-colors cursor-pointer"
            >
              News
            </button>
            <button
              onClick={() => { setIsMobileMenuOpen(false); setIsAboutOpen(true); }}
              className="w-full text-left px-4 py-3 rounded-xl text-[#1A365D] font-medium hover:bg-gray-50 transition-colors cursor-pointer"
            >
              About Us
            </button>
            <button
              onClick={() => { setIsMobileMenuOpen(false); setIsCareersOpen(true); }}
              className="w-full text-left px-4 py-3 rounded-xl text-[#1A365D] font-medium hover:bg-gray-50 transition-colors cursor-pointer"
            >
              Careers
            </button>
            <div className="pt-2">
              <button
                onClick={() => scrollToSection('contact')}
                className="w-full bg-[#DC2626] text-white py-3 rounded-xl font-semibold hover:bg-[#B91C1C] transition-colors whitespace-nowrap"
              >
                Get a Quote
              </button>
            </div>
          </div>
        )}
      </nav>

      <AboutModal isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} />
      <CareersModal isOpen={isCareersOpen} onClose={() => setIsCareersOpen(false)} />
    </>
  );
}
